import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import { Box, Typography } from "@mui/material";
import React from "react";
import { usePagesTranslation } from "../../../../pages/locales";
import { useSlidingAppearance } from "../lib/AppearanceContext";
import { slidingElevatedCardSx } from "../lib/appearance";
import HomeLightBlueMist from "./HomeLightBlueMist";

const systemFont =
    '-apple-system, BlinkMacSystemFont, "SF Pro Text", "Segoe UI", sans-serif';

/**
 * Minimal empty state for My Puzzles (Screen 6).
 * @param {"progress" | "complete"} variant
 */
export default function MyPuzzlesEmptyState({ variant = "progress" }) {
    const { t } = usePagesTranslation();
    const { tokens, isDark } = useSlidingAppearance();
    const isComplete = variant === "complete";

    const message = isComplete
        ? t("native.myPuzzles.emptyComplete", {
              defaultValue: "No completed puzzles yet.",
          })
        : t("native.myPuzzles.emptyProgress", {
              defaultValue: "No puzzles in progress. Play from Library.",
          });

    const Icon = isComplete ? TaskAltOutlinedIcon : GridViewOutlinedIcon;

    return (
        <Box
            sx={{
                ...slidingElevatedCardSx(tokens),
                position: "relative",
                overflow: "hidden",
                isolation: "isolate",
                borderRadius: "16px",
                bgcolor: isDark ? "rgba(21, 37, 63, 0.82)" : "rgba(255, 255, 255, 0.78)",
                background: isDark ? "rgba(21, 37, 63, 0.82)" : "rgba(255, 255, 255, 0.78)",
                backdropFilter: "blur(8px)",
                WebkitBackdropFilter: "blur(8px)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                py: 5,
                px: 3,
                minHeight: 200,
            }}
            role="status"
        >
            <HomeLightBlueMist isDark={isDark} />
            <Box
                sx={{
                    position: "relative",
                    zIndex: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <Box
                    sx={{
                        width: 72,
                        height: 72,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: tokens.iconMutedBg,
                        mb: 2,
                    }}
                >
                    <Icon sx={{ fontSize: 36, color: tokens.iconMuted }} aria-hidden />
                </Box>
                <Typography
                    sx={{
                        fontFamily: systemFont,
                        fontSize: "0.9375rem",
                        lineHeight: 1.5,
                        color: tokens.textMuted,
                        maxWidth: 280,
                    }}
                >
                    {message}
                </Typography>
            </Box>
        </Box>
    );
}
